import { render, staticRenderFns } from "./EnvioCredenciaisDialog.vue?vue&type=template&id=73da6b74&"
import script from "./EnvioCredenciaisDialog.vue?vue&type=script&lang=js&"
export * from "./EnvioCredenciaisDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports